import Instruction from 'app/src/engine/instructions/Instruction';
import MovableItem from 'app/src/engine/movable-items/MovableItem';

export default class Robot extends MovableItem {
	public nextInstruction: Instruction | null = null;

	public alive = true;

	public clone(): Robot {
		throw new Error('Subclasses must override.');
	}
}
